export default function lerp (start : number, end : number, amt : number) {
	if (amt >= 1) return end;
	if (amt <= 0) return start;
	return (1-amt)*start+amt*end;
}